<template>
  <div>
    <base-header
      class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
      style="
        min-height: 600px;
        background-size: cover;
        background-position: center top;
      "
    >
      <!-- Mask -->
      <span class="mask bg-gradient-success opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-8 col-md-10">
            <h1 class="display-2 text-white">Hola Usuario</h1>
            <p class="text-white mt-0 mb-5">
              Aquí puede ver los detalles del ejercicio
            </p>
            
            <router-link to="/ejercicios" class="btn btn-info"><span>Volver a Ejercicios</span></router-link>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-12 order-xl-1">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-xl-9">
                  <h3 class="mb-0">Detalles del ejercicio</h3>
                </div>
                <div class="col-xl-3">
                  <router-link v-if="edit_permission" :to="{ name: 'Editar Ejercicio', params: { ejercicioId: ejercicioId}}"><base-button type="primary" size="sm"> Editar</base-button></router-link>
                  <base-button v-if="edit_permission" type="primary" size="sm" @click="deleteEjercicio(ejercicioId)"> Eliminar</base-button>
                </div>
              </div>
            </div>
            <template>
              <form @submit.prevent>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <h3>Nombre: {{ejercicio_name}}</h3>
                    </div>
                  </div>
                </div>
                <img :src="ejercicio_img" alt="" style="max-width: 100%;">
                <hr class="my-4" />
                <!-- Address -->
                <h6 class="heading-small text-muted mb-4">Detalles</h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-md-12">

                      <span v-html="ejercicio_description"></span>
                    </div>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { db } from '../../firebaseDb';
import { auth } from '../../firebaseDb';

export default {
  name: "show-ejercicio",
  props: {
        ejercicioId: {
          type: String,
          defalut: "ASD"
        }
  },
  data() {
    return {
      user: auth.currentUser,
      ejercicio_name: {
        type: String,
        default: 'Nombre del ejercicio'
      },
      ejercicio_description: {
        type: String,
        default: 'Descripción del ejercicio'
      },
      ejercicio_img: {
        type: String,
        default: 'URL de la imagen'
      },
      edit_permission: false
    };
  },
  created: function() {
    var self = this;
    this.track();
    db.collection('ejercicios').doc(this.ejercicioId)
    .onSnapshot({ includeMetadataChanges: true }, (doc) => {
      if(doc.exists){
        try{
          let ejercicioName = doc.data().ejercicio_name
          self.ejercicio_name = ejercicioName

          let ejercicioDesc = doc.data().ejercicio_description
          self.ejercicio_description = ejercicioDesc

          let ejercicioimg = doc.data().ejercicio_img
          self.ejercicio_img = ejercicioimg

        }catch(error){
          console.log(error)
        }
      }
    })
      db.collection('users').doc(this.user.uid).get()
      .then(function(doc){
        if(doc.exists){
          try{
            if (doc.data().rol == 'admin') {
              self.edit_permission = true
            }
          }catch(error){
            console.log(error)
          }
        }
      })
  },
  methods: {
      deleteEjercicio(id){
        if (window.confirm("¿Está seguro de eliminar este ejercicio?")) {
          db.collection('ejercicios').doc(id).delete().then(() => {
              console.log("Document deleted!");
              this.$router.push({name: 'Ejercicios'});
          })
          .catch((error) => {
              console.error(error);
          })
        }
      },
      track() {
        this.$gtag.event("seen_exercise", {
          'event_category': "exercise",
          'event_label': "exercise_seen",
          'value': 1
        })
      },
    } 
};
</script>
<style>
img{
  max-width: 95%;
}
</style>